import { Modal, Stack, Text } from "@mantine/core";
import { observer } from "mobx-react";
import { useStores } from "@/hooks/useStores";

export const LoginNoticeModal = observer(() => {
    const { appStore } = useStores();

    return (
        <Modal
            centered
            onClose={() => appStore.setShowLoginNotice(false)}
            opened={appStore.showLoginNotice}
            title="Inloggning pausad">
            <Stack gap="md">
                <Text size="sm">
                    Vi bygger om kontofunktionen. Inloggning och personliga konton är tillfälligt avstängda.
                </Text>
                <Text c="dimmed" size="sm">
                    Lokala spellistor och lyssningshistorik fungerar fortfarande på den här enheten.
                </Text>
            </Stack>
        </Modal>
    );
});
